import React, { useEffect, useState } from 'react';
import { fetchEnquiryById } from '../../utils/enquiryApi';
import { getStorageValues } from '../../shared/CommonFunctions';
import VehicleEnquiryGrid from './VehicleEnquiryGrid';

function ViewEnquiry({ selectedRow }) {
  const [loading, setLoading] = useState(false);
  const [header, setHeader] = useState(null);
  const [vehicleEntries, setVehicleEntries] = useState([]);

  useEffect(() => {
    const load = async () => {
      if (!selectedRow?.EnquiryId) {
        setHeader(null);
        setVehicleEntries([]);
        return;
      }
      setLoading(true);
      try {
        const result = await fetchEnquiryById({
          userId: getStorageValues('userId'),
          enquiryId: selectedRow.EnquiryId
        });
        setHeader(result?.header || null);

        const details = result?.details || [];
        setVehicleEntries(
          details.map((d) => ({
            id: d.EnquiryDetailsId,
            VehicleName: d.VehicleId,
            VehicleColor: d.ColorId,
            VehicleCost: d.VehicleCost,
            PaymentType: d.PaymentType,
            DownPayment: d.DownPayment,
            EMITenure: d.EMITenure,
            EMIAmount: d.EMIAmount,
            ProcessingFees: d.ProcessingFees,
          }))
        );
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [selectedRow]);

  if (loading) {
    return <div className="p-2">Loading...</div>;
  }

  return (
    <>
      <div className="row">
        <div className="col-lg-8 col-sm-6 col-12 mb-3">
          <label className="form-label">Customer Name</label>
          <input type="text" className="form-control" value={header?.CustomerName || ''} disabled />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Mobile No</label>
          <input type="text" className="form-control" value={header?.MobileNo || ''} disabled />
        </div>

        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Enquiry Source</label>
          <input
            type="text"
            className="form-control"
            value={header?.EnquirySourceLabel || header?.EnquirySource || ''}
            disabled
          />
        </div>

        {(String(header?.EnquirySourceLabel || header?.EnquirySource || '').toLowerCase() === 'reference') && (
          <div className="col-lg-4 col-sm-6 col-12 mb-3">
            <label className="form-label">Reference Name</label>
            <input type="text" className="form-control" value={header?.ReferenceName || ''} disabled />
          </div>
        )}

        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Area</label>
          <input type="text" className="form-control" value={header?.Area || ''} disabled />
        </div>
      </div>

      <div className="mt-2">
        <h6 className="mb-2">Vehicle Enquiry Details</h6>
        <VehicleEnquiryGrid data={vehicleEntries} onAction={"View"}/>
      </div>
    </>
  );
}

export default ViewEnquiry;